import { waitForPageLoadAnalytics } from "./pageLoad";

let pageLoadTrackingSent = false;

waitForPageLoadAnalytics.then(() => {
  pageLoadTrackingSent = true;
});

export const hasPageLoadFired = () => pageLoadTrackingSent;
